import React from 'react';
import { useForm } from 'react-hook-form';
import { Building, Globe } from 'lucide-react';
import Button from '../../../../components/common/Button';
import Alert from '../../../../components/common/Alert';

export default function CompanyRegistration({ onComplete, initialData = {} }) {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: initialData
  });

  return (
    <form onSubmit={handleSubmit(onComplete)} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-navy mb-1">
          Company Name
        </label>
        <div className="relative">
          <Building className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 w-5 h-5" />
          <input
            type="text"
            {...register('name', { required: 'Company name is required' })}
            className="w-full pl-10 pr-4 py-2 rounded-lg border-2 border-light-purple focus:border-primary focus:ring focus:ring-primary/20 transition-colors"
            placeholder="Your Company Name"
          />
        </div>
        {errors.name && (
          <span className="text-sm text-error mt-1">{errors.name.message}</span>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-navy mb-1">
          Domain
        </label>
        <div className="relative">
          <Globe className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 w-5 h-5" />
          <input
            type="text"
            {...register('domain', {
              required: 'Domain is required',
              pattern: {
                value: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
                message: 'Please enter a valid domain'
              }
            })}
            className="w-full pl-10 pr-4 py-2 rounded-lg border-2 border-light-purple focus:border-primary focus:ring focus:ring-primary/20 transition-colors"
            placeholder="example.com"
          />
        </div>
        {errors.domain && (
          <span className="text-sm text-error mt-1">{errors.domain.message}</span>
        )}
      </div>

      <Alert type="info">
        This domain will be used for all email verifications. Make sure it's your company's primary domain.
      </Alert>

      <div className="flex justify-end">
        <Button type="submit">Continue</Button>
      </div>
    </form>
  );
}